import { createContext } from 'react'

export const DropdownSearchContext = createContext(false)
